export { SvelteComponentDev as SvelteComponent, SvelteComponentTyped, afterUpdate, beforeUpdate, createEventDispatcher, getAllContexts, getContext, hasContext, onDestroy, onMount, setContext, tick } from './internal/index.mjs';



//////////////////
// WEBPACK FOOTER
// ./~/svelte/index.mjs
// module id = 41
// module chunks = 6